import React from 'react';

export function Checkbox({
  id,
  name,
  checked,
  onChange,
  className = '',
  ...props
}) {
  return (
    <input
      type="checkbox"
      id={id}
      name={name}
      checked={checked}
      onChange={onChange}
      className={`h-4 w-4 text-blue-600 border-gray-300 rounded ${className}`}
      {...props}
    />
  );
}
